var _g, _g2, _g3, _g4, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _g5, _path23, _path24, _path25, _g6, _g7, _g8, _g9, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _g0, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _g1, _g10, _path85, _path86, _path87, _g11, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIcon404 = function SvgIcon404(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 816,
    height: 330,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#1D1D1B",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "m78.621 280.6 166.38.07 24.69-6.88-66.88-10.37z",
    opacity: 0.06
  }), /*#__PURE__*/React.createElement("path", {
    d: "m86.25 280.48 158.75.12 24.38-6.75-63.76-9.75z",
    opacity: 0.12
  }), /*#__PURE__*/React.createElement("path", {
    d: "m93.879 280.351 151.12.19 24.06-6.62-60.62-9.13z",
    opacity: 0.19
  }), /*#__PURE__*/React.createElement("path", {
    d: "m101.5 280.23 143.5.25 23.75-6.5-57.5-8.5z",
    opacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "m109.121 280.1 135.88.32 23.44-6.38-54.38-7.87z",
    opacity: 0.31
  }), /*#__PURE__*/React.createElement("path", {
    d: "m116.75 279.98 128.25.37 23.12-6.25-51.24-7.25z",
    opacity: 0.38
  }), /*#__PURE__*/React.createElement("path", {
    d: "m124.379 279.851 120.62.44 22.81-6.12-48.12-6.63z",
    opacity: 0.44
  }), /*#__PURE__*/React.createElement("path", {
    d: "m132 279.73 113 .5 22.5-6-45-6z",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "m139.621 279.6 105.38.57 22.19-5.88-41.88-5.37z",
    opacity: 0.56
  }), /*#__PURE__*/React.createElement("path", {
    d: "m147.25 279.48 97.75.62 21.88-5.75-38.76-4.75z",
    opacity: 0.62
  }), /*#__PURE__*/React.createElement("path", {
    d: "m154.879 279.351 90.12.69 21.56-5.62-35.62-4.13z",
    opacity: 0.69
  }), /*#__PURE__*/React.createElement("path", {
    d: "m162.5 279.23 82.5.75 21.25-5.5-32.5-3.5z",
    opacity: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "m170.121 279.1 74.88.82 20.94-5.38-29.38-2.87z",
    opacity: 0.81
  }), /*#__PURE__*/React.createElement("path", {
    d: "m177.75 278.98 67.25.87 20.62-5.25-26.24-2.25z",
    opacity: 0.88
  }), /*#__PURE__*/React.createElement("path", {
    d: "m185.379 278.851 59.62.94 20.31-5.12-23.12-1.63z",
    opacity: 0.94
  }), /*#__PURE__*/React.createElement("path", {
    d: "m193 278.73 52 1 20-5-20-1z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "#1D1D1B",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "m117.406 278.55 132.66.09 19.56-3.37-53.2-4.84z",
    opacity: 0.06
  }), /*#__PURE__*/React.createElement("path", {
    d: "m123.488 278.361 126.58.19 19.18-3.44-50.58-4.48z",
    opacity: 0.12
  }), /*#__PURE__*/React.createElement("path", {
    d: "m129.566 278.18 120.5.27 18.81-3.5-47.97-4.12z",
    opacity: 0.19
  }), /*#__PURE__*/React.createElement("path", {
    d: "m135.648 277.991 114.42.37 18.43-3.57-45.34-3.76z",
    opacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "m141.727 277.81 108.34.46 18.06-3.64-42.73-3.4z",
    opacity: 0.31
  }), /*#__PURE__*/React.createElement("path", {
    d: "m147.809 277.63 102.26.55 17.68-3.7-40.11-3.05z",
    opacity: 0.38
  }), /*#__PURE__*/React.createElement("path", {
    d: "m153.887 277.441 96.18.65 17.31-3.77-37.5-2.69z",
    opacity: 0.44
  }), /*#__PURE__*/React.createElement("path", {
    d: "m159.969 277.26 90.1.73 16.94-3.83-34.88-2.33z",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "m166.047 277.071 84.02.83 16.56-3.9-32.26-1.97z",
    opacity: 0.56
  }), /*#__PURE__*/React.createElement("path", {
    d: "m172.129 276.89 77.94.92 16.19-3.97-29.65-1.61z",
    opacity: 0.62
  }), /*#__PURE__*/React.createElement("path", {
    d: "m178.207 276.71 71.86 1.01 15.81-4.03-27.03-1.26z",
    opacity: 0.69
  }), /*#__PURE__*/React.createElement("path", {
    d: "m184.289 276.521 65.78 1.11 15.44-4.1-24.41-.9z",
    opacity: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "m190.367 276.34 59.7 1.19 15.07-4.16-21.8-.54z",
    opacity: 0.81
  }), /*#__PURE__*/React.createElement("path", {
    d: "m196.449 276.15 53.62 1.29 14.69-4.23-19.18-.19z",
    opacity: 0.88
  }), /*#__PURE__*/React.createElement("path", {
    d: "m202.527 275.971 47.54 1.38 14.32-4.3-16.57.17z",
    opacity: 0.94
  }), /*#__PURE__*/React.createElement("path", {
    d: "m208.609 275.79 41.46 1.47 13.94-4.36-13.94.52z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.15
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon_404_svg__a)",
    d: "M240.691 279.101s145.19 5 128.71-6.45c-12.35-8.61-121.69.53-121.69.53z",
    opacity: 0.06
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon_404_svg__b)",
    d: "M239.379 279.101s139.35 4.73 124.4-6.33c-11.2-8.33-117.37.41-117.37.41l-7.02 5.92z",
    opacity: 0.12
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon_404_svg__c)",
    d: "M238.059 279.111s133.5 4.5 120.08-6.21c-10.06-8.03-113.06.29-113.06.29z",
    opacity: 0.19
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon_404_svg__d)",
    d: "M236.75 279.112s127.65 4.25 115.77-6.08c-8.91-7.75-108.75.17-108.75.17l-7.02 5.92z",
    opacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon_404_svg__e)",
    d: "M235.441 279.121s121.81 3.99 111.46-5.96c-7.76-7.46-104.44.04-104.44.04z",
    opacity: 0.31
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon_404_svg__f)",
    d: "M234.121 279.12s115.97 3.73 107.15-5.84c-6.62-7.18-100.12-.08-100.12-.08l-7.02 5.92z",
    opacity: 0.38
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon_404_svg__g)",
    d: "M232.809 279.13s110.12 3.47 102.83-5.71c-5.47-6.9-95.81-.2-95.81-.2l-7.02 5.92z",
    opacity: 0.44
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon_404_svg__h)",
    d: "M231.5 279.132s104.27 3.21 98.52-5.59c-4.33-6.62-91.5-.33-91.5-.33z",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon_404_svg__i)",
    d: "M230.191 279.14s98.42 2.94 94.21-5.47c-3.18-6.35-87.19-.45-87.19-.45z",
    opacity: 0.56
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon_404_svg__j)",
    d: "M228.879 279.141s92.58 2.67 89.9-5.34c-2.04-6.08-82.87-.58-82.87-.58l-7.02 5.92z",
    opacity: 0.62
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon_404_svg__k)",
    d: "M227.559 279.152s86.74 2.38 85.58-5.22c-.88-5.82-78.56-.7-78.56-.7z",
    opacity: 0.69
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon_404_svg__l)",
    d: "M226.25 279.151s80.91 2.1 81.27-5.1c.28-5.56-74.25-.82-74.25-.82z",
    opacity: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon_404_svg__m)",
    d: "M224.941 279.162s75.1 1.82 76.96-4.97c1.45-5.29-69.94-.95-69.94-.95z",
    opacity: 0.81
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon_404_svg__n)",
    d: "M223.621 279.16s69.3 1.55 72.65-4.85c2.63-5.02-65.62-1.07-65.62-1.07l-7.02 5.92z",
    opacity: 0.88
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon_404_svg__o)",
    d: "M222.309 279.171s63.49 1.3 68.33-4.73c3.8-4.73-61.31-1.19-61.31-1.19z",
    opacity: 0.94
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1D1D1B",
    d: "M221 279.171s57.68 1.05 64.02-4.6c4.98-4.44-57-1.32-57-1.32z"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon_404_svg__p)",
    d: "M249.891 278.02s79.67 2.74 70.63-3.54c-6.78-4.72-66.77.29-66.77.29l-3.85 3.25z",
    opacity: 0.06
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon_404_svg__q)",
    d: "M249.168 278.021s76.47 2.6 68.26-3.47c-6.14-4.57-64.41.23-64.41.23l-3.85 3.25z",
    opacity: 0.12
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon_404_svg__r)",
    d: "M248.449 278.021s73.26 2.47 65.89-3.41c-5.52-4.41-62.04.16-62.04.16z",
    opacity: 0.19
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon_404_svg__s)",
    d: "M247.73 278.03s70.05 2.33 63.53-3.34c-4.89-4.25-59.67.09-59.67.09l-3.85 3.25z",
    opacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon_404_svg__t)",
    d: "M247.012 278.03s66.84 2.19 61.16-3.27c-4.26-4.09-57.31.02-57.31.02z",
    opacity: 0.31
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon_404_svg__u)",
    d: "M246.289 278.03s63.64 2.05 58.8-3.2c-3.63-3.94-54.94-.04-54.94-.04l-3.85 3.25z",
    opacity: 0.38
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon_404_svg__v)",
    d: "M245.57 278.041s60.43 1.91 56.43-3.13c-3-3.79-52.58-.11-52.58-.11l-3.85 3.25z",
    opacity: 0.44
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon_404_svg__w)",
    d: "M244.852 278.04s57.22 1.76 54.06-3.07c-2.37-3.63-50.21-.18-50.21-.18z",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon_404_svg__x)",
    d: "M244.129 278.04s54.01 1.61 51.7-3c-1.75-3.48-47.84-.25-47.84-.25l-3.85 3.25z",
    opacity: 0.56
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon_404_svg__y)",
    d: "M243.41 278.041s50.8 1.46 49.33-2.93c-1.12-3.34-45.48-.32-45.48-.32z",
    opacity: 0.62
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon_404_svg__z)",
    d: "M242.691 278.052s47.6 1.31 46.96-2.87c-.49-3.19-43.11-.38-43.11-.38z",
    opacity: 0.69
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon_404_svg__A)",
    d: "M241.969 278.051s44.4 1.15 44.6-2.8c.15-3.05-40.74-.45-40.74-.45l-3.85 3.25z",
    opacity: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon_404_svg__B)",
    d: "M241.25 278.05s41.21 1 42.23-2.73c.79-2.9-38.38-.52-38.38-.52z",
    opacity: 0.81
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon_404_svg__C)",
    d: "M240.531 278.06s38.03.85 39.86-2.66c1.44-2.75-36.01-.59-36.01-.59z",
    opacity: 0.88
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon_404_svg__D)",
    d: "M239.809 278.061s34.84.71 37.5-2.59c2.09-2.6-33.64-.66-33.64-.66l-3.85 3.25z",
    opacity: 0.94
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1D1D1B",
    d: "M239.09 278.061s31.65.58 35.13-2.53c2.73-2.44-31.28-.72-31.28-.72z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon_404_svg__E)",
    d: "M265 190.73v-143l.04-.01L245 38.73l-13 152z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon_404_svg__F)",
    d: "m180 106.731-48 84h31.09l34.89-54.65 12.02-25.35c0-3.96-11.61-7.68-11.02-19l-1.64-.12c-1.55 4.02-12.92 6.64-17.34 15.12"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon_404_svg__G)",
    d: "m180 106.731-48 84h31.09l34.89-54.65 12.02-25.35c0-3.96-11.61-7.68-11.02-19l-1.64-.12c-1.55 4.02-12.92 6.64-17.34 15.12",
    opacity: 0.55,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon_404_svg__H)",
    d: "m274 190.73-7 19 7 18 18-2v-35z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon_404_svg__I)",
    d: "m274 190.73-7 19 7 18 18-2v-35z",
    opacity: 0.55
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon_404_svg__J)",
    d: "m245 227.73-17 25 17 26 20-5v-46z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon_404_svg__K)",
    d: "m245 227.73-17 25 17 26 20-5v-46z",
    opacity: 0.55
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.8,
    style: {
      mixBlendMode: "multiply"
    }
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon_404_svg__L)",
    d: "m197.36 91.73-25.93 84.76 29.07-44.41.5-40.24z",
    opacity: 0.12
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon_404_svg__M)",
    d: "m197.359 91.73-22.5 79.52 26.14-39.93V91.84z",
    opacity: 0.25
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon_404_svg__N)",
    d: "m197.359 91.73-19.07 74.28 23.21-35.46-.5-38.71z",
    opacity: 0.38
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon_404_svg__O)",
    d: "m197.359 91.73-15.64 69.04 20.28-30.98-1-37.95z",
    opacity: 0.5
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon_404_svg__P)",
    d: "m197.358 91.73-12.21 63.8 17.35-26.51-1.5-37.18z",
    opacity: 0.62
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon_404_svg__Q)",
    d: "m197.358 91.73-8.78 58.55 14.42-22.02-2-36.42z",
    opacity: 0.75
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon_404_svg__R)",
    d: "m197.362 91.73-5.35 53.31 11.49-17.55-2.5-35.65z",
    opacity: 0.88
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon_404_svg__S)",
    d: "m197.359 91.73-1.91 48.07 8.55-13.07-3-34.89z"
  }))), /*#__PURE__*/React.createElement("g", {
    opacity: 0.55,
    style: {
      mixBlendMode: "multiply"
    }
  }, _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon_404_svg__T)",
    d: "m244.598 230.08 20.4 30.4v-33.25l-19.63-1.5z",
    opacity: 0.12
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon_404_svg__U)",
    d: "m244.648 229.89 20.35 26.34v-29.5l-19.63-2z",
    opacity: 0.25
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon_404_svg__V)",
    d: "m244.711 229.69 20.29 22.29v-25.75l-19.63-2.5z",
    opacity: 0.38
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon_404_svg__W)",
    d: "M244.77 229.5 265 247.73v-22l-19.63-3z",
    opacity: 0.5
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon_404_svg__X)",
    d: "m244.828 229.31 20.17 14.17v-18.25l-19.63-3.5z",
    opacity: 0.62
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon_404_svg__Y)",
    d: "m244.879 229.12 20.12 10.11v-14.5l-19.63-4z",
    opacity: 0.75
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon_404_svg__Z)",
    d: "m244.938 228.92 20.059 6.06v-10.75l-19.63-4.5z",
    opacity: 0.88
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon_404_svg__aa)",
    d: "m245 228.73 20 2v-7l-19.63-5z"
  }))), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon_404_svg__ab)",
    d: "M274 190.73h-29v-152h-51.12L94.02 194.04v33.64H197.7l.3 51.05h47v-51h29zm-76 0h-61l51.41-80.37c4.42-8.48 7.41-14.73 8.96-18.74l1.64.12c-.58 11.32-1 19.04-1 23v76z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon_404_svg__ac)",
    d: "M265 190.73v-143l.04-.01L245 38.73v152z",
    opacity: 0.15,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon_404_svg__ad)",
    d: "M265 190.73v-143l.04-.01L245 38.73v152z",
    opacity: 0.55
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    fill: "#fff",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M245 225.73h-1.02v53H245zM196.94 92.661l-.6-.04c-1.55 4.02-4.54 8.64-8.96 17.12l-53.38 83h64v-2h-61l51.41-80.37c4.06-7.79 6.9-13.68 8.54-17.7zM244.998 190.73v-152h-51.12l-.64 1h50.74l.12 153h29l-.12 35h1.02v-37z"
  }))), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fill: "#1D1D1B",
    d: "M197.98 279.73h47l20-5v-1l-20 5h-47",
    opacity: 0.55
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M274 226.73h-29v1h29z",
    opacity: 0.25
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fill: "#64605F",
    d: "M197.69 226.73H94.02v.95h103.67z",
    opacity: 0.15
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    fill: "#1D1D1B",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "m458.109 279.379 166.38.06 24.69-6.88-66.88-10.37z",
    opacity: 0.06
  }), /*#__PURE__*/React.createElement("path", {
    d: "m465.738 279.251 158.75.13 24.37-6.75-63.75-9.75z",
    opacity: 0.12
  }), /*#__PURE__*/React.createElement("path", {
    d: "m473.359 279.131 151.13.18 24.06-6.62-60.62-9.13z",
    opacity: 0.19
  }), /*#__PURE__*/React.createElement("path", {
    d: "m480.988 279 143.5.25 23.75-6.5-57.5-8.5z",
    opacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "m488.609 278.879 135.88.31 23.44-6.38-54.38-7.87z",
    opacity: 0.31
  }), /*#__PURE__*/React.createElement("path", {
    d: "m496.238 278.751 128.25.38 23.12-6.25-51.25-7.25z",
    opacity: 0.38
  }), /*#__PURE__*/React.createElement("path", {
    d: "m503.859 278.631 120.63.43 22.81-6.12-48.12-6.63z",
    opacity: 0.44
  }), /*#__PURE__*/React.createElement("path", {
    d: "m511.488 278.5 113 .5 22.5-6-45-6z",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "m519.109 278.379 105.38.56 22.19-5.88-41.88-5.37z",
    opacity: 0.56
  }), /*#__PURE__*/React.createElement("path", {
    d: "m526.738 278.251 97.75.63 21.87-5.75-38.75-4.75z",
    opacity: 0.62
  }), /*#__PURE__*/React.createElement("path", {
    d: "m534.359 278.131 90.13.68 21.56-5.62-35.62-4.13z",
    opacity: 0.69
  }), /*#__PURE__*/React.createElement("path", {
    d: "m541.988 278 82.5.75 21.25-5.5-32.5-3.5z",
    opacity: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "m549.609 277.879 74.88.81 20.94-5.38-29.38-2.87z",
    opacity: 0.81
  }), /*#__PURE__*/React.createElement("path", {
    d: "m557.238 277.751 67.25.88 20.62-5.25-26.25-2.25z",
    opacity: 0.88
  }), /*#__PURE__*/React.createElement("path", {
    d: "m564.859 277.631 59.63.93 20.31-5.12-23.12-1.63z",
    opacity: 0.94
  }), /*#__PURE__*/React.createElement("path", {
    d: "m572.488 277.5 52 1 20-5-20-1z"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    fill: "#1D1D1B",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "m496.895 277.319 132.65.09 19.56-3.37-53.19-4.84z",
    opacity: 0.06
  }), /*#__PURE__*/React.createElement("path", {
    d: "m502.977 277.13 126.57.19 19.19-3.44-50.58-4.48z",
    opacity: 0.12
  }), /*#__PURE__*/React.createElement("path", {
    d: "m509.055 276.95 120.49.27 18.82-3.5-47.97-4.12z",
    opacity: 0.19
  }), /*#__PURE__*/React.createElement("path", {
    d: "m515.137 276.761 114.41.37 18.44-3.57-45.34-3.76z",
    opacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "m521.215 276.58 108.33.46 18.07-3.63-42.73-3.41z",
    opacity: 0.31
  }), /*#__PURE__*/React.createElement("path", {
    d: "m527.297 276.399 102.25.55 17.69-3.7-40.11-3.05z",
    opacity: 0.38
  }), /*#__PURE__*/React.createElement("path", {
    d: "m533.375 276.21 96.17.65 17.32-3.77-37.5-2.69z",
    opacity: 0.44
  }), /*#__PURE__*/React.createElement("path", {
    d: "m539.457 276.03 90.09.73 16.95-3.83-34.88-2.33z",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "m545.535 275.841 84.01.83 16.57-3.9-32.26-1.97z",
    opacity: 0.56
  }), /*#__PURE__*/React.createElement("path", {
    d: "m551.617 275.66 77.93.92 16.2-3.96-29.65-1.62z",
    opacity: 0.62
  }), /*#__PURE__*/React.createElement("path", {
    d: "m557.695 275.479 71.85 1.01 15.82-4.03-27.03-1.26z",
    opacity: 0.69
  }), /*#__PURE__*/React.createElement("path", {
    d: "m563.777 275.29 65.77 1.11 15.45-4.1-24.42-.9z",
    opacity: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "m569.855 275.11 59.69 1.19 15.07-4.16-21.789-.54z",
    opacity: 0.81
  }), /*#__PURE__*/React.createElement("path", {
    d: "m575.938 274.921 53.609 1.29 14.7-4.23-19.179-.18z",
    opacity: 0.88
  }), /*#__PURE__*/React.createElement("path", {
    d: "m582.016 274.74 47.53 1.38 14.33-4.29-16.57.17z",
    opacity: 0.94
  }), /*#__PURE__*/React.createElement("path", {
    d: "m588.086 274.56 41.46 1.47 13.95-4.36-13.95.53z"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.15
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon_404_svg__ae)",
    d: "M620.18 277.87s145.19 5 128.71-6.45c-12.35-8.61-121.69.54-121.69.54l-7.02 5.92z",
    opacity: 0.06
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon_404_svg__af)",
    d: "M618.859 277.87s139.35 4.73 124.4-6.33c-11.2-8.33-117.37.41-117.37.41l-7.02 5.92z",
    opacity: 0.12
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon_404_svg__ag)",
    d: "M617.547 277.881s133.5 4.5 120.08-6.21c-10.06-8.03-113.06.29-113.06.29z",
    opacity: 0.19
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon_404_svg__ah)",
    d: "M616.238 277.88s127.66 4.25 115.77-6.08c-8.91-7.75-108.75.16-108.75.16z",
    opacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon_404_svg__ai)",
    d: "M614.93 277.89s121.81 3.99 111.46-5.96c-7.76-7.46-104.44.04-104.44.04z",
    opacity: 0.31
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon_404_svg__aj)",
    d: "M613.609 277.89s115.97 3.73 107.15-5.84c-6.62-7.18-100.12-.08-100.12-.08l-7.02 5.92z",
    opacity: 0.38
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon_404_svg__ak)",
    d: "M612.297 277.9s110.12 3.47 102.83-5.71c-5.47-6.9-95.81-.21-95.81-.21z",
    opacity: 0.44
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon_404_svg__al)",
    d: "M610.988 277.902s104.27 3.21 98.52-5.59c-4.33-6.62-91.5-.33-91.5-.33z",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon_404_svg__am)",
    d: "M609.68 277.91s98.42 2.94 94.21-5.47c-3.18-6.35-87.19-.45-87.19-.45z",
    opacity: 0.56
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon_404_svg__an)",
    d: "M608.359 277.91s92.58 2.67 89.9-5.34c-2.04-6.08-82.87-.58-82.87-.58l-7.02 5.92z",
    opacity: 0.62
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon_404_svg__ao)",
    d: "M607.047 277.921s86.74 2.38 85.58-5.22c-.88-5.82-78.56-.7-78.56-.7z",
    opacity: 0.69
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon_404_svg__ap)",
    d: "M605.738 277.92s80.91 2.1 81.27-5.1c.28-5.56-74.25-.82-74.25-.82z",
    opacity: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon_404_svg__aq)",
    d: "M604.43 277.931s75.1 1.82 76.96-4.97c1.45-5.29-69.94-.95-69.94-.95z",
    opacity: 0.81
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon_404_svg__ar)",
    d: "M603.109 277.94s69.3 1.55 72.65-4.85c2.63-5.02-65.62-1.07-65.62-1.07l-7.02 5.92z",
    opacity: 0.88
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon_404_svg__as)",
    d: "M601.797 277.941s63.49 1.3 68.33-4.73c3.8-4.74-61.31-1.19-61.31-1.19z",
    opacity: 0.94
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1D1D1B",
    d: "M600.488 277.95s57.68 1.05 64.02-4.6c4.98-4.44-57-1.32-57-1.32z"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon_404_svg__at)",
    d: "M629.379 276.79s79.67 2.74 70.63-3.54c-6.78-4.72-66.77.29-66.77.29l-3.85 3.25z",
    opacity: 0.06
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon_404_svg__au)",
    d: "M628.656 276.791s76.47 2.6 68.26-3.47c-6.14-4.57-64.41.23-64.41.23l-3.85 3.25z",
    opacity: 0.12
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon_404_svg__av)",
    d: "M627.938 276.8s73.25 2.47 65.89-3.41c-5.52-4.41-62.041.16-62.041.16z",
    opacity: 0.19
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon_404_svg__aw)",
    d: "M627.219 276.8s70.05 2.33 63.53-3.34c-4.89-4.25-59.67.09-59.67.09l-3.85 3.25z",
    opacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon_404_svg__ax)",
    d: "M626.5 276.799s66.84 2.19 61.16-3.27c-4.26-4.09-57.31.02-57.31.02z",
    opacity: 0.31
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon_404_svg__ay)",
    d: "M625.777 276.8s63.64 2.05 58.8-3.2c-3.63-3.94-54.94-.05-54.94-.05l-3.85 3.25z",
    opacity: 0.38
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon_404_svg__az)",
    d: "M625.059 276.81s60.43 1.91 56.43-3.14c-3-3.79-52.58-.11-52.58-.11z",
    opacity: 0.44
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon_404_svg__aA)",
    d: "M624.34 276.809s57.22 1.76 54.06-3.07c-2.37-3.63-50.21-.18-50.21-.18z",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon_404_svg__aB)",
    d: "M623.617 276.81s54.01 1.62 51.7-3c-1.75-3.48-47.84-.25-47.84-.25l-3.85 3.25z",
    opacity: 0.56
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon_404_svg__aC)",
    d: "M622.898 276.821s50.8 1.46 49.33-2.93c-1.12-3.34-45.48-.32-45.48-.32z",
    opacity: 0.62
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon_404_svg__aD)",
    d: "M622.18 276.821s47.6 1.31 46.96-2.87c-.49-3.19-43.11-.38-43.11-.38z",
    opacity: 0.69
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon_404_svg__aE)",
    d: "M621.457 276.82s44.4 1.15 44.6-2.8c.15-3.05-40.74-.45-40.74-.45l-3.85 3.25z",
    opacity: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon_404_svg__aF)",
    d: "M620.738 276.82s41.21 1 42.23-2.73c.79-2.91-38.38-.52-38.38-.52z",
    opacity: 0.81
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon_404_svg__aG)",
    d: "M620.02 276.83s38.03.85 39.86-2.66c1.44-2.75-36.01-.59-36.01-.59z",
    opacity: 0.88
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon_404_svg__aH)",
    d: "M619.297 276.83s34.84.71 37.5-2.59c2.09-2.6-33.64-.66-33.64-.66l-3.85 3.25z",
    opacity: 0.94
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1D1D1B",
    d: "M618.578 276.831s31.65.58 35.13-2.53c2.73-2.44-31.28-.72-31.28-.72z"
  }))), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon_404_svg__aI)",
    d: "M644.488 189.5v-143l.04-.01-20.04-8.99-13 152z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon_404_svg__aJ)",
    d: "m559.488 105.501-48 84h31.09l34.89-54.65 12.02-25.35c0-3.96-11.61-7.68-11.02-19l-1.64-.12c-1.55 4.02-12.92 6.64-17.34 15.12"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon_404_svg__aK)",
    d: "m559.488 105.501-48 84h31.09l34.89-54.65 12.02-25.35c0-3.96-11.61-7.68-11.02-19l-1.64-.12c-1.55 4.02-12.92 6.64-17.34 15.12",
    opacity: 0.55,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon_404_svg__aL)",
    d: "m653.488 189.5-7 19 7 18 18-2v-35z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon_404_svg__aM)",
    d: "m653.488 189.5-7 19 7 18 18-2v-35z",
    opacity: 0.55
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon_404_svg__aN)",
    d: "m624.488 226.5-17 25 17 26 20-5v-46z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon_404_svg__aO)",
    d: "m624.488 226.5-17 25 17 26 20-5v-46z",
    opacity: 0.55
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.8,
    style: {
      mixBlendMode: "multiply"
    }
  }, _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon_404_svg__aP)",
    d: "m576.848 90.5-25.93 84.76 29.07-44.41.5-40.23z",
    opacity: 0.12
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon_404_svg__aQ)",
    d: "m576.848 90.5-22.5 79.52 26.14-39.93V90.62z",
    opacity: 0.25
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon_404_svg__aR)",
    d: "m576.847 90.5-19.07 74.28 23.21-35.46-.5-38.7z",
    opacity: 0.38
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon_404_svg__aS)",
    d: "m576.847 90.5-15.64 69.04 20.28-30.98-1-37.94z",
    opacity: 0.5
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon_404_svg__aT)",
    d: "m576.847 90.5-12.21 63.8 17.35-26.51-1.5-37.17z",
    opacity: 0.62
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon_404_svg__aU)",
    d: "m576.846 90.5-8.78 58.56 14.42-22.03-2-36.41z",
    opacity: 0.75
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon_404_svg__aV)",
    d: "m576.85 90.5-5.35 53.32 11.49-17.56-2.5-35.64z",
    opacity: 0.88
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon_404_svg__aW)",
    d: "m576.85 90.5-1.92 48.07 8.56-13.07-3-34.88z"
  }))), /*#__PURE__*/React.createElement("g", {
    opacity: 0.55,
    style: {
      mixBlendMode: "multiply"
    }
  }, _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon_404_svg__aX)",
    d: "m624.078 228.85 20.41 30.4V226l-19.63-1.5z",
    opacity: 0.12
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon_404_svg__aY)",
    d: "m624.137 228.66 20.35 26.34v-29.5l-19.63-2z",
    opacity: 0.25
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon_404_svg__aZ)",
    d: "m624.199 228.46 20.29 22.29V225l-19.63-2.5z",
    opacity: 0.38
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon_404_svg__ba)",
    d: "m624.258 228.27 20.23 18.23v-22l-19.63-3z",
    opacity: 0.5
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon_404_svg__bb)",
    d: "m624.309 228.08 20.18 14.17V224l-19.63-3.5z",
    opacity: 0.62
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon_404_svg__bc)",
    d: "m624.367 227.89 20.12 10.11v-14.5l-19.63-4z",
    opacity: 0.75
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon_404_svg__bd)",
    d: "m624.426 227.69 20.06 6.06V223l-19.63-4.5z",
    opacity: 0.88
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon_404_svg__be)",
    d: "m624.488 227.5 20 2v-7l-19.63-5z"
  }))), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon_404_svg__bf)",
    d: "M653.98 189.5h-29v-152h-51.12L474 192.81v33.64h103.67l.3 51.05h47v-51h29v-37zm-76 0h-61l51.41-80.37c4.42-8.48 7.41-14.73 8.96-18.74l1.64.12c-.58 11.32-1 19.04-1 23v76z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon_404_svg__bg)",
    d: "M644.488 189.5v-143l.04-.01-20.04-8.99v152z",
    opacity: 0.15,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon_404_svg__bh)",
    d: "M644.488 189.5v-143l.04-.01-20.04-8.99v152z",
    opacity: 0.55
  })), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", {
    fill: "#fff",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M624.489 224.5h-1.02v53h1.02zM576.428 91.43l-.6-.04c-1.55 4.02-4.54 8.641-8.96 17.121l-53.38 83h64v-2h-61l51.41-80.37c4.06-7.79 6.9-13.68 8.54-17.7zM624.489 189.5v-152h-51.12l-.65 1h50.75l.12 153h29l-.12 35h1.02v-37z"
  }))), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    fill: "#1D1D1B",
    d: "M577.469 278.5h47l20-5v-1l-20 5h-47",
    opacity: 0.55
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M653.488 225.5h-29v1h29z",
    opacity: 0.25
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    fill: "#64605F",
    d: "M577.178 225.5h-103.67v.95h103.67z",
    opacity: 0.15
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    style: {
      mixBlendMode: "multiply"
    }
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon_404_svg__bi)",
    d: "M473.5 197.81v33.64l18.63.05c4.09-21.18 1.49-48.51-5.12-62.77l-13.5 29.08z",
    opacity: 0.12,
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon_404_svg__bj)",
    d: "M473 197.81v33.64l17 .05c4.69-20.83 2.84-47.74-3-62.77z",
    opacity: 0.25,
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon_404_svg__bk)",
    d: "M472.5 197.81v33.64l15.38.05c5.28-20.49 4.21-46.97-.88-62.77z",
    opacity: 0.38,
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon_404_svg__bl)",
    d: "M472 197.81v33.64l13.75.05c5.88-20.15 5.56-46.21 1.25-62.77z",
    opacity: 0.5,
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon_404_svg__bm)",
    d: "M471.5 197.81v33.64l12.13.05c6.47-19.8 6.92-45.44 3.38-62.77l-15.5 29.08z",
    opacity: 0.62,
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon_404_svg__bn)",
    d: "M471 197.81v33.64l10.5.05c7.06-19.46 8.29-44.68 5.5-62.77z",
    opacity: 0.75,
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon_404_svg__bo)",
    d: "M470.5 197.81v33.64l8.88.05c7.66-19.12 9.64-43.91 7.62-62.77z",
    opacity: 0.88,
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon_404_svg__bp)",
    d: "M470 197.81v33.64l7.25.05c8.25-18.77 11-43.15 9.75-62.77z",
    style: {
      mixBlendMode: "multiply"
    }
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#1D1D1B",
    opacity: 0.4,
    style: {
      mixBlendMode: "multiply"
    }
  }, _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "m283.52 279.881 122.52.06 25.72-10.89-51.89-16.67z",
    opacity: 0.06
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "m289.438 279.75 117.04.13 25.039-10.5-49.47-15.63z",
    opacity: 0.12
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "m295.348 279.631 111.57.18 24.35-10.1-47.03-14.58z",
    opacity: 0.19
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "m301.27 279.5 106.08.25 23.68-9.71-44.61-13.54z",
    opacity: 0.25
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "m307.18 279.381 100.61.31 23-9.32-42.19-12.49z",
    opacity: 0.31
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "m313.098 279.25 95.13.38 22.32-8.93-39.77-11.45z",
    opacity: 0.38
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "m319.02 279.131 89.65.43 21.63-8.53-37.34-10.4z",
    opacity: 0.44
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "m324.93 279 84.17.5 20.96-8.14-34.91-9.36z",
    opacity: 0.5
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "m330.848 278.881 78.69.56 20.28-7.75-32.49-8.31z",
    opacity: 0.56
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "m336.758 278.75 73.22.63 19.6-7.36-30.07-7.27z",
    opacity: 0.62
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "m342.68 278.631 67.74.68 18.91-6.96-27.64-6.22z",
    opacity: 0.69
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "m348.598 278.5 62.25.75 18.24-6.57-25.21-5.18z",
    opacity: 0.75
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "m354.508 278.381 56.78.81 17.56-6.18-22.79-4.13z",
    opacity: 0.81
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "m360.43 278.25 51.3.88 16.88-5.79-20.37-3.09z",
    opacity: 0.88
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "m366.34 278.131 45.83.93 16.19-5.39-17.94-2.04z",
    opacity: 0.94
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "m372.258 278 40.34 1 15.52-5-15.52-1z"
  }))), /*#__PURE__*/React.createElement("g", {
    fill: "#1D1D1B",
    opacity: 0.75,
    style: {
      mixBlendMode: "multiply"
    }
  }, _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "m324.691 279.78 81.25.12 14.93-6.38-26.95-10.04z",
    opacity: 0.06
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "m328.32 279.56 77.51.23 14.91-6.06-25.86-9.58z",
    opacity: 0.12
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "m331.961 279.341 73.75.35 14.91-5.76-24.79-9.12z",
    opacity: 0.19
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "m335.59 279.12 70 .46 14.9-5.44-23.71-8.66z",
    opacity: 0.25
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "m339.23 278.9 66.25.58 14.88-5.13-22.63-8.2z",
    opacity: 0.31
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "m342.859 278.68 62.5.69 14.87-4.82-21.55-7.73z",
    opacity: 0.38
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "m346.492 278.46 58.76.81 14.85-4.51-20.47-7.27z",
    opacity: 0.44
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "m350.129 278.24 55 .92 14.84-4.2-19.39-6.8z",
    opacity: 0.5
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "m353.762 278.02 51.25 1.04 14.84-3.89-18.31-6.34z",
    opacity: 0.56
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "m357.402 277.8 47.5 1.15 14.82-3.57-17.23-5.88z",
    opacity: 0.62
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "m361.031 277.58 43.75 1.27 14.81-3.27-16.15-5.42z",
    opacity: 0.69
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "m364.672 277.36 39.99 1.38 14.8-2.95-15.07-4.96z",
    opacity: 0.75
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "m368.301 277.13 36.24 1.51 14.79-2.64-13.99-4.5z",
    opacity: 0.81
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "m371.941 276.91 32.49 1.62 14.78-2.33-12.92-4.03z",
    opacity: 0.88
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "m375.57 276.69 28.74 1.74 14.77-2.02-11.84-3.57z",
    opacity: 0.94
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "m379.199 276.47 25 1.85 14.75-1.71-10.75-3.1z"
  }))), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon_404_svg__bq)",
    d: "M408.5 278.37s151.22 5 134.05-6.45c-12.87-8.61-126.74.53-126.74.53z",
    opacity: 0.06
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon_404_svg__br)",
    d: "M407.141 278.37s145.14 4.73 129.56-6.33c-11.67-8.33-122.25.41-122.25.41z",
    opacity: 0.12
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon_404_svg__bs)",
    d: "M405.77 278.381s139.04 4.5 125.07-6.21c-10.48-8.03-117.76.29-117.76.29z",
    opacity: 0.19
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon_404_svg__bt)",
    d: "M404.398 278.381s132.96 4.25 120.58-6.08c-9.28-7.75-113.27.17-113.27.17l-7.31 5.92z",
    opacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon_404_svg__bu)",
    d: "M403.039 278.39s126.87 3.99 116.09-5.96c-8.09-7.46-108.77.04-108.77.04l-7.31 5.92z",
    opacity: 0.31
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon_404_svg__bv)",
    d: "M401.672 278.39s120.78 3.74 111.6-5.84c-6.89-7.18-104.28-.08-104.28-.08l-7.31 5.92z",
    opacity: 0.38
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon_404_svg__bw)",
    d: "M400.301 278.4s114.69 3.48 107.1-5.71c-5.7-6.9-99.79-.2-99.79-.2l-7.31 5.92z",
    opacity: 0.44
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon_404_svg__bx)",
    d: "M398.941 278.411s108.6 3.21 102.61-5.59c-4.51-6.62-95.3-.33-95.3-.33z",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon_404_svg__by)",
    d: "M397.57 278.41s102.51 2.94 98.12-5.47c-3.31-6.35-90.81-.45-90.81-.45z",
    opacity: 0.56
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon_404_svg__bz)",
    d: "M396.199 278.42s96.42 2.67 93.63-5.34c-2.12-6.08-86.32-.58-86.32-.58z",
    opacity: 0.62
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon_404_svg__bA)",
    d: "M394.828 278.421s90.34 2.39 89.14-5.22c-.92-5.82-81.82-.7-81.82-.7l-7.31 5.92z",
    opacity: 0.69
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon_404_svg__bB)",
    d: "M393.469 278.43s84.27 2.1 84.65-5.1c.29-5.56-77.33-.82-77.33-.82l-7.31 5.92z",
    opacity: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon_404_svg__bC)",
    d: "M392.102 278.431s78.22 1.82 80.15-4.97c1.51-5.29-72.84-.95-72.84-.95z",
    opacity: 0.81
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon_404_svg__bD)",
    d: "M390.73 278.44s72.18 1.55 75.66-4.85c2.74-5.02-68.35-1.07-68.35-1.07z",
    opacity: 0.88
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon_404_svg__bE)",
    d: "M389.371 278.441s66.13 1.29 71.17-4.73c3.96-4.74-63.86-1.19-63.86-1.19z",
    opacity: 0.94
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1D1D1B",
    d: "M388 278.45s60.08 1.05 66.68-4.6c5.19-4.44-59.37-1.32-59.37-1.32z"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.55
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon_404_svg__bF)",
    d: "M403.891 279.29s79.67 2.74 70.63-3.54c-6.78-4.72-66.77.29-66.77.29l-3.85 3.25z",
    opacity: 0.06
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon_404_svg__bG)",
    d: "M403.168 279.291s76.47 2.6 68.26-3.47c-6.14-4.57-64.41.23-64.41.23l-3.85 3.25z",
    opacity: 0.12
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon_404_svg__bH)",
    d: "M402.449 279.3s73.26 2.47 65.89-3.41c-5.52-4.41-62.04.16-62.04.16z",
    opacity: 0.19
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon_404_svg__bI)",
    d: "M401.73 279.3s70.05 2.33 63.53-3.34c-4.89-4.25-59.67.09-59.67.09l-3.85 3.25z",
    opacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon_404_svg__bJ)",
    d: "M401.012 279.299s66.84 2.19 61.16-3.27c-4.26-4.09-57.31.02-57.31.02z",
    opacity: 0.31
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon_404_svg__bK)",
    d: "M400.289 279.311s63.64 2.05 58.8-3.2c-3.63-3.94-54.94-.04-54.94-.04l-3.85 3.25z",
    opacity: 0.38
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon_404_svg__bL)",
    d: "M399.57 279.31s60.43 1.91 56.43-3.14c-3-3.79-52.58-.11-52.58-.11z",
    opacity: 0.44
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon_404_svg__bM)",
    d: "M398.852 279.309s57.22 1.76 54.06-3.07c-2.37-3.63-50.21-.18-50.21-.18z",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon_404_svg__bN)",
    d: "M398.129 279.31s54.01 1.62 51.7-3c-1.75-3.48-47.84-.25-47.84-.25l-3.85 3.25z",
    opacity: 0.56
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon_404_svg__bO)",
    d: "M397.41 279.321s50.8 1.46 49.33-2.93c-1.12-3.34-45.48-.32-45.48-.32z",
    opacity: 0.62
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon_404_svg__bP)",
    d: "M396.691 279.321s47.6 1.31 46.96-2.86c-.49-3.19-43.11-.38-43.11-.38l-3.85 3.25z",
    opacity: 0.69
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon_404_svg__bQ)",
    d: "M395.969 279.32s44.4 1.15 44.6-2.8c.15-3.05-40.74-.45-40.74-.45l-3.85 3.25z",
    opacity: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon_404_svg__bR)",
    d: "M395.25 279.331s41.21 1 42.23-2.73c.79-2.9-38.38-.52-38.38-.52z",
    opacity: 0.81
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon_404_svg__bS)",
    d: "M394.531 279.33s38.03.85 39.86-2.66c1.44-2.75-36.01-.59-36.01-.59z",
    opacity: 0.88
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon_404_svg__bT)",
    d: "M393.809 279.33s34.84.71 37.5-2.59c2.09-2.6-33.64-.66-33.64-.66l-3.85 3.25z",
    opacity: 0.94
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1D1D1B",
    d: "M393.09 279.331s31.65.58 35.13-2.53c2.73-2.44-31.28-.72-31.28-.72z"
  }))), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon_404_svg__bU)",
    d: "M361 164c0-40.91-1.74-72.55 13-94 9.95-14.48-7.98-26.9 8.02-31.6L359.03 43c-17.2 3.87-30.96 13.34-41.27 28.45-13.85 20.3-20.78 49.82-20.78 88.55 0 66.67 20.19 104.86 61.01 112l19.67 3.69c-37.79-10.98-16.67-46.01-16.67-111.69z"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon_404_svg__bV)",
    d: "M386.73 230.59c4.71 5.71 10.57 8.59 17.58 8.59 20.86 0 54.69-27.29 54.69-82.14s-33.62-82.39-54.05-82.39c-6.77 0-12.49 2.73-17.16 8.17 11.27 9.31 16.91 33.83 16.91 73.6 0 40.58-5.99 65.31-17.96 74.17z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon_404_svg__bW)",
    d: "M386.73 230.59c4.71 5.71 10.57 8.59 17.58 8.59 20.86 0 54.69-27.29 54.69-82.14s-33.62-82.39-54.05-82.39c-6.77 0-12.49 2.73-17.16 8.17 11.27 9.31 16.91 33.83 16.91 73.6 0 40.58-5.99 65.31-17.96 74.17z",
    style: {
      mixBlendMode: "soft-light"
    }
  }), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon_404_svg__bX)",
    d: "M465.21 247.08C479.74 225.8 487 195.2 487 155.27 487 75.09 460.39 35 407.18 35c-27.99 0-49.35 10.72-64.09 32.17s-22.11 52.62-22.11 93.54c0 78.87 27.24 118.3 81.73 118.3 27.14 0 47.97-10.64 62.5-31.92zm-29.61-90.16c0 54.85-10.43 82.27-31.29 82.27s-32.09-26.6-32.09-79.8c0-56.49 10.91-84.73 32.72-84.73 20.43 0 30.65 27.42 30.65 82.27z"
  })), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    fill: "#fff",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M405.309 240.18c20.86 0 31.29-27.42 31.29-82.27 0-40.42-5.56-65.92-16.65-76.56 10.43 11.19 15.65 36.37 15.65 75.56 0 54.85-10.43 82.27-31.29 82.27-5.87 0-10.92-2.01-15.18-6.01 4.46 4.66 9.85 7.01 16.18 7.01"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.98 161.7q0-61.365 22.11-93.54C358.83 46.72 380.19 36 408.18 36c21.08 0 37.98 6.3 50.71 18.88C446.05 41.63 428.82 35 407.18 35c-27.99 0-49.35 10.72-64.09 32.17s-22.11 52.62-22.11 93.54c0 47.11 9.73 80.15 29.17 99.12-18.78-19.12-28.17-51.82-28.17-98.12z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon_404_svg__a",
    x1: 240.691,
    x2: 370.701,
    y1: 274.571,
    y2: 274.571,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1D1D1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1D1D1B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon_404_svg__b",
    x1: 239.379,
    x2: 364.889,
    y1: 274.641,
    y2: 274.641,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1D1D1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1D1D1B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon_404_svg__c",
    x1: 238.059,
    x2: 359.089,
    y1: 274.721,
    y2: 274.721,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1D1D1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1D1D1B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon_404_svg__d",
    x1: 236.75,
    x2: 353.3,
    y1: 274.802,
    y2: 274.802,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1D1D1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1D1D1B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon_404_svg__e",
    x1: 235.441,
    x2: 347.521,
    y1: 274.881,
    y2: 274.881,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1D1D1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1D1D1B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon_404_svg__f",
    x1: 234.121,
    x2: 341.751,
    y1: 274.96,
    y2: 274.96,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1D1D1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1D1D1B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon_404_svg__g",
    x1: 232.809,
    x2: 335.989,
    y1: 275.03,
    y2: 275.03,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1D1D1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1D1D1B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon_404_svg__h",
    x1: 231.5,
    x2: 330.25,
    y1: 275.112,
    y2: 275.112,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1D1D1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1D1D1B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon_404_svg__i",
    x1: 230.191,
    x2: 324.531,
    y1: 275.18,
    y2: 275.18,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1D1D1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1D1D1B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon_404_svg__j",
    x1: 228.879,
    x2: 318.829,
    y1: 275.251,
    y2: 275.251,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1D1D1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1D1D1B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon_404_svg__k",
    x1: 227.559,
    x2: 313.159,
    y1: 275.332,
    y2: 275.332,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1D1D1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1D1D1B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon_404_svg__l",
    x1: 226.25,
    x2: 307.52,
    y1: 275.401,
    y2: 275.401,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1D1D1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1D1D1B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon_404_svg__m",
    x1: 224.941,
    x2: 301.921,
    y1: 275.472,
    y2: 275.472,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1D1D1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1D1D1B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon_404_svg__n",
    x1: 223.621,
    x2: 296.351,
    y1: 275.55,
    y2: 275.55,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1D1D1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1D1D1B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon_404_svg__o",
    x1: 222.309,
    x2: 290.809,
    y1: 275.631,
    y2: 275.631,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1D1D1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1D1D1B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon_404_svg__p",
    x1: 249.891,
    x2: 321.231,
    y1: 275.53,
    y2: 275.53,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1D1D1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1D1D1B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon_404_svg__q",
    x1: 249.168,
    x2: 318.048,
    y1: 275.571,
    y2: 275.571,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1D1D1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1D1D1B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon_404_svg__r",
    x1: 248.449,
    x2: 314.869,
    y1: 275.621,
    y2: 275.621,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1D1D1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1D1D1B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon_404_svg__s",
    x1: 247.73,
    x2: 311.69,
    y1: 275.66,
    y2: 275.66,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1D1D1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1D1D1B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon_404_svg__t",
    x1: 247.012,
    x2: 308.512,
    y1: 275.7,
    y2: 275.7,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1D1D1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1D1D1B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon_404_svg__u",
    x1: 246.289,
    x2: 305.349,
    y1: 275.75,
    y2: 275.75,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1D1D1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1D1D1B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon_404_svg__v",
    x1: 245.57,
    x2: 302.19,
    y1: 275.791,
    y2: 275.791,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1D1D1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1D1D1B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon_404_svg__w",
    x1: 244.852,
    x2: 299.042,
    y1: 275.83,
    y2: 275.83,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1D1D1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1D1D1B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon_404_svg__x",
    x1: 244.129,
    x2: 295.899,
    y1: 275.87,
    y2: 275.87,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1D1D1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1D1D1B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon_404_svg__y",
    x1: 243.41,
    x2: 292.77,
    y1: 275.911,
    y2: 275.911,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1D1D1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1D1D1B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon_404_svg__z",
    x1: 242.691,
    x2: 289.661,
    y1: 275.952,
    y2: 275.952,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1D1D1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1D1D1B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon_404_svg__A",
    x1: 241.969,
    x2: 286.569,
    y1: 275.991,
    y2: 275.991,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1D1D1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1D1D1B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon_404_svg__B",
    x1: 241.25,
    x2: 283.49,
    y1: 276.03,
    y2: 276.03,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1D1D1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1D1D1B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon_404_svg__C",
    x1: 240.531,
    x2: 280.431,
    y1: 276.07,
    y2: 276.07,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1D1D1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1D1D1B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon_404_svg__D",
    x1: 239.809,
    x2: 277.389,
    y1: 276.121,
    y2: 276.121,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1D1D1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1D1D1B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon_404_svg__E",
    x1: 248.02,
    x2: 249.02,
    y1: 19.23,
    y2: 217.73,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A8A8A8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon_404_svg__F",
    x1: 214.52,
    x2: 128.15,
    y1: 83.761,
    y2: 214.171,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#707070"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#727272"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#929292"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#A5A5A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#ADADAD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#A6A6A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#939393"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#757575"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#707070"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon_404_svg__G",
    x1: 207.23,
    x2: 151.89,
    y1: 165.871,
    y2: 133.201,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon_404_svg__H",
    x1: 301.78,
    x2: 266.28,
    y1: 208.06,
    y2: 209.56,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A8A8A8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon_404_svg__I",
    x1: 270.56,
    x2: 295.23,
    y1: 209.6,
    y2: 206.93,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon_404_svg__J",
    x1: 273.44,
    x2: 239.94,
    y1: 247.71,
    y2: 254.21,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A8A8A8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon_404_svg__K",
    x1: 244.16,
    x2: 273.49,
    y1: 248.05,
    y2: 262.05,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon_404_svg__L",
    x1: 188.93,
    x2: 184.96,
    y1: 91.32,
    y2: 175.74,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1D1D1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#1A1A18"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon_404_svg__M",
    x1: 191.199,
    x2: 186.589,
    y1: 94.171,
    y2: 174.68,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1D1D1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#1A1A18"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon_404_svg__N",
    x1: 193.379,
    x2: 188.219,
    y1: 96.68,
    y2: 173.07,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1D1D1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#1A1A18"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon_404_svg__O",
    x1: 195.469,
    x2: 189.869,
    y1: 98.871,
    y2: 170.89,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1D1D1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#1A1A18"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon_404_svg__P",
    x1: 197.488,
    x2: 191.548,
    y1: 100.71,
    y2: 168.13,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1D1D1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#1A1A18"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon_404_svg__Q",
    x1: 199.438,
    x2: 193.278,
    y1: 102.2,
    y2: 164.79,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1D1D1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#1A1A18"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon_404_svg__R",
    x1: 201.122,
    x2: 194.862,
    y1: 103.3,
    y2: 160.83,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1D1D1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#1A1A18"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon_404_svg__S",
    x1: 201.319,
    x2: 195.089,
    y1: 103.86,
    y2: 156.09,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon_404_svg__T",
    x1: 241.057,
    x2: 271.789,
    y1: 218.534,
    y2: 250.899,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1D1D1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#0A0A09"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon_404_svg__U",
    x1: 243.145,
    x2: 273.115,
    y1: 220.466,
    y2: 248.686,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1D1D1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#0C0C0B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon_404_svg__V",
    x1: 243.301,
    x2: 272.481,
    y1: 221.715,
    y2: 245.06,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1D1D1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#0F0F0E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon_404_svg__W",
    x1: 243.039,
    x2: 271.245,
    y1: 222.987,
    y2: 241.419,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1D1D1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#121211"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon_404_svg__X",
    x1: 245.605,
    x2: 272.775,
    y1: 224.129,
    y2: 238.371,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1D1D1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#191917"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon_404_svg__Y",
    x1: 248.422,
    x2: 274.33,
    y1: 224.148,
    y2: 235.167,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1D1D1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon_404_svg__Z",
    x1: 249.026,
    x2: 273.511,
    y1: 224.028,
    y2: 232.858,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1D1D1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon_404_svg__aa",
    x1: 249.338,
    x2: 272.526,
    y1: 224.362,
    y2: 231.964,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon_404_svg__ab",
    x1: 198.55,
    x2: 177.05,
    y1: -25.059,
    y2: 323.94,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D6D6D6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon_404_svg__ac",
    x1: 269.52,
    x2: 242.86,
    y1: 114.37,
    y2: 115.03,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon_404_svg__ad",
    x1: 238.56,
    x2: 266.56,
    y1: 115.51,
    y2: 114.18,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon_404_svg__ae",
    x1: 620.18,
    x2: 750.19,
    y1: 273.34,
    y2: 273.34,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1D1D1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1D1D1B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon_404_svg__af",
    x1: 618.859,
    x2: 744.379,
    y1: 273.41,
    y2: 273.41,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1D1D1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1D1D1B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon_404_svg__ag",
    x1: 617.547,
    x2: 738.577,
    y1: 273.501,
    y2: 273.501,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1D1D1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1D1D1B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon_404_svg__ah",
    x1: 616.238,
    x2: 732.788,
    y1: 273.57,
    y2: 273.57,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1D1D1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1D1D1B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon_404_svg__ai",
    x1: 614.93,
    x2: 727.01,
    y1: 273.65,
    y2: 273.65,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1D1D1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1D1D1B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon_404_svg__aj",
    x1: 613.609,
    x2: 721.239,
    y1: 273.73,
    y2: 273.73,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1D1D1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1D1D1B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon_404_svg__ak",
    x1: 612.297,
    x2: 715.477,
    y1: 273.8,
    y2: 273.8,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1D1D1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1D1D1B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon_404_svg__al",
    x1: 610.988,
    x2: 709.738,
    y1: 273.882,
    y2: 273.882,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1D1D1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1D1D1B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon_404_svg__am",
    x1: 609.68,
    x2: 704.02,
    y1: 273.95,
    y2: 273.95,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1D1D1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1D1D1B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon_404_svg__an",
    x1: 608.359,
    x2: 698.319,
    y1: 274.03,
    y2: 274.03,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1D1D1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1D1D1B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon_404_svg__ao",
    x1: 607.047,
    x2: 692.647,
    y1: 274.101,
    y2: 274.101,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1D1D1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1D1D1B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon_404_svg__ap",
    x1: 605.738,
    x2: 687.008,
    y1: 274.17,
    y2: 274.17,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1D1D1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1D1D1B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon_404_svg__aq",
    x1: 604.43,
    x2: 681.41,
    y1: 274.241,
    y2: 274.241,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1D1D1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1D1D1B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon_404_svg__ar",
    x1: 603.109,
    x2: 675.829,
    y1: 274.32,
    y2: 274.32,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1D1D1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1D1D1B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon_404_svg__as",
    x1: 601.797,
    x2: 670.297,
    y1: 274.401,
    y2: 274.401,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1D1D1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1D1D1B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon_404_svg__at",
    x1: 629.379,
    x2: 700.719,
    y1: 274.3,
    y2: 274.3,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1D1D1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1D1D1B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon_404_svg__au",
    x1: 628.656,
    x2: 697.536,
    y1: 274.351,
    y2: 274.351,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1D1D1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1D1D1B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon_404_svg__av",
    x1: 627.938,
    x2: 694.348,
    y1: 274.39,
    y2: 274.39,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1D1D1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1D1D1B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon_404_svg__aw",
    x1: 627.219,
    x2: 691.179,
    y1: 274.43,
    y2: 274.43,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1D1D1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1D1D1B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon_404_svg__ax",
    x1: 626.5,
    x2: 688,
    y1: 274.479,
    y2: 274.479,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1D1D1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1D1D1B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon_404_svg__ay",
    x1: 625.777,
    x2: 684.837,
    y1: 274.52,
    y2: 274.52,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1D1D1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1D1D1B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon_404_svg__az",
    x1: 625.059,
    x2: 681.679,
    y1: 274.56,
    y2: 274.56,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1D1D1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1D1D1B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon_404_svg__aA",
    x1: 624.34,
    x2: 678.53,
    y1: 274.599,
    y2: 274.599,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1D1D1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1D1D1B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon_404_svg__aB",
    x1: 623.617,
    x2: 675.387,
    y1: 274.64,
    y2: 274.64,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1D1D1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1D1D1B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon_404_svg__aC",
    x1: 622.898,
    x2: 672.258,
    y1: 274.681,
    y2: 274.681,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1D1D1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1D1D1B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon_404_svg__aD",
    x1: 622.18,
    x2: 669.15,
    y1: 274.721,
    y2: 274.721,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1D1D1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1D1D1B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon_404_svg__aE",
    x1: 621.457,
    x2: 666.047,
    y1: 274.76,
    y2: 274.76,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1D1D1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1D1D1B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon_404_svg__aF",
    x1: 620.738,
    x2: 662.978,
    y1: 274.8,
    y2: 274.8,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1D1D1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1D1D1B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon_404_svg__aG",
    x1: 620.02,
    x2: 659.92,
    y1: 274.84,
    y2: 274.84,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1D1D1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1D1D1B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon_404_svg__aH",
    x1: 619.297,
    x2: 656.877,
    y1: 274.89,
    y2: 274.89,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1D1D1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1D1D1B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon_404_svg__aI",
    x1: 627.508,
    x2: 628.508,
    y1: 18,
    y2: 216.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A8A8A8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon_404_svg__aJ",
    x1: 594.008,
    x2: 507.638,
    y1: 82.531,
    y2: 212.941,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#707070"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#727272"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#929292"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#A5A5A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#ADADAD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#A6A6A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#939393"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#757575"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#707070"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon_404_svg__aK",
    x1: 586.718,
    x2: 531.378,
    y1: 164.641,
    y2: 131.971,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon_404_svg__aL",
    x1: 681.268,
    x2: 645.768,
    y1: 206.83,
    y2: 208.33,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A8A8A8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon_404_svg__aM",
    x1: 650.048,
    x2: 674.718,
    y1: 208.37,
    y2: 205.71,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon_404_svg__aN",
    x1: 652.928,
    x2: 619.428,
    y1: 246.48,
    y2: 252.98,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A8A8A8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon_404_svg__aO",
    x1: 623.638,
    x2: 652.978,
    y1: 246.83,
    y2: 260.83,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon_404_svg__aP",
    x1: 568.408,
    x2: 564.448,
    y1: 90.09,
    y2: 174.51,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1D1D1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#1A1A18"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon_404_svg__aQ",
    x1: 570.688,
    x2: 566.078,
    y1: 92.94,
    y2: 173.45,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1D1D1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#1A1A18"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon_404_svg__aR",
    x1: 572.867,
    x2: 567.707,
    y1: 95.46,
    y2: 171.84,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1D1D1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#1A1A18"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon_404_svg__aS",
    x1: 574.957,
    x2: 569.357,
    y1: 97.64,
    y2: 169.66,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1D1D1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#1A1A18"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon_404_svg__aT",
    x1: 576.977,
    x2: 571.037,
    y1: 99.48,
    y2: 166.9,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1D1D1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#1A1A18"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon_404_svg__aU",
    x1: 578.926,
    x2: 572.766,
    y1: 100.97,
    y2: 163.56,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1D1D1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#1A1A18"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon_404_svg__aV",
    x1: 580.61,
    x2: 574.34,
    y1: 102.07,
    y2: 159.6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1D1D1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#1A1A18"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon_404_svg__aW",
    x1: 580.81,
    x2: 574.58,
    y1: 102.63,
    y2: 154.86,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon_404_svg__aX",
    x1: 621.425,
    x2: 652.148,
    y1: 217.305,
    y2: 249.671,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1D1D1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#0A0A09"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon_404_svg__aY",
    x1: 624.471,
    x2: 654.441,
    y1: 219.232,
    y2: 247.452,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1D1D1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#0C0C0B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon_404_svg__aZ",
    x1: 622.957,
    x2: 652.144,
    y1: 220.505,
    y2: 243.846,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1D1D1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#0F0F0E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon_404_svg__ba",
    x1: 620.789,
    x2: 648.989,
    y1: 221.792,
    y2: 240.218,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1D1D1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#121211"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon_404_svg__bb",
    x1: 625.27,
    x2: 652.44,
    y1: 222.902,
    y2: 237.144,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1D1D1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#191917"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon_404_svg__bc",
    x1: 629.766,
    x2: 655.663,
    y1: 222.901,
    y2: 233.924,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1D1D1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon_404_svg__bd",
    x1: 629.387,
    x2: 653.863,
    y1: 222.814,
    y2: 231.641,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1D1D1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon_404_svg__be",
    x1: 628.84,
    x2: 652.027,
    y1: 223.134,
    y2: 230.736,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon_404_svg__bf",
    x1: 578.52,
    x2: 557.02,
    y1: -26.29,
    y2: 322.71,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D6D6D6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon_404_svg__bg",
    x1: 649.008,
    x2: 622.348,
    y1: 113.14,
    y2: 113.8,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon_404_svg__bh",
    x1: 618.048,
    x2: 646.048,
    y1: 114.28,
    y2: 112.95,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon_404_svg__bi",
    x1: 486.13,
    x2: 482.09,
    y1: 166.79,
    y2: 233.91,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon_404_svg__bj",
    x1: 485.45,
    x2: 480.75,
    y1: 166.55,
    y2: 233.78,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon_404_svg__bk",
    x1: 484.81,
    x2: 479.44,
    y1: 166.29,
    y2: 233.64,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon_404_svg__bl",
    x1: 484.21,
    x2: 478.17,
    y1: 166.03,
    y2: 233.49,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon_404_svg__bm",
    x1: 483.65,
    x2: 476.94,
    y1: 165.76,
    y2: 233.32,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon_404_svg__bn",
    x1: 483.14,
    x2: 475.75,
    y1: 165.48,
    y2: 233.15,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon_404_svg__bo",
    x1: 482.67,
    x2: 474.61,
    y1: 165.19,
    y2: 232.96,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon_404_svg__bp",
    x1: 482.26,
    x2: 473.51,
    y1: 164.9,
    y2: 232.77,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon_404_svg__bq",
    x1: 408.5,
    x2: 543.92,
    y1: 273.84,
    y2: 273.84,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1D1D1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1D1D1B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon_404_svg__br",
    x1: 407.141,
    x2: 537.871,
    y1: 273.91,
    y2: 273.91,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1D1D1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1D1D1B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon_404_svg__bs",
    x1: 405.77,
    x2: 531.83,
    y1: 274.001,
    y2: 274.001,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1D1D1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1D1D1B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon_404_svg__bt",
    x1: 404.398,
    x2: 525.798,
    y1: 274.071,
    y2: 274.071,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1D1D1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1D1D1B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon_404_svg__bu",
    x1: 403.039,
    x2: 519.779,
    y1: 274.15,
    y2: 274.15,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1D1D1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1D1D1B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon_404_svg__bv",
    x1: 401.672,
    x2: 513.762,
    y1: 274.23,
    y2: 274.23,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1D1D1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1D1D1B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon_404_svg__bw",
    x1: 400.301,
    x2: 507.771,
    y1: 274.31,
    y2: 274.31,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1D1D1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1D1D1B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon_404_svg__bx",
    x1: 398.941,
    x2: 501.791,
    y1: 274.381,
    y2: 274.381,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1D1D1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1D1D1B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon_404_svg__by",
    x1: 397.57,
    x2: 495.83,
    y1: 274.46,
    y2: 274.46,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1D1D1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1D1D1B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon_404_svg__bz",
    x1: 396.199,
    x2: 489.889,
    y1: 274.53,
    y2: 274.53,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1D1D1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1D1D1B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon_404_svg__bA",
    x1: 394.828,
    x2: 483.978,
    y1: 274.601,
    y2: 274.601,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1D1D1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1D1D1B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon_404_svg__bB",
    x1: 393.469,
    x2: 478.119,
    y1: 274.67,
    y2: 274.67,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1D1D1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1D1D1B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon_404_svg__bC",
    x1: 392.102,
    x2: 472.282,
    y1: 274.741,
    y2: 274.741,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1D1D1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1D1D1B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon_404_svg__bD",
    x1: 390.73,
    x2: 466.47,
    y1: 274.82,
    y2: 274.82,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1D1D1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1D1D1B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon_404_svg__bE",
    x1: 389.371,
    x2: 460.711,
    y1: 274.901,
    y2: 274.901,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1D1D1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1D1D1B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon_404_svg__bF",
    x1: 403.891,
    x2: 475.231,
    y1: 276.81,
    y2: 276.81,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1D1D1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1D1D1B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon_404_svg__bG",
    x1: 403.168,
    x2: 472.048,
    y1: 276.851,
    y2: 276.851,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1D1D1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1D1D1B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon_404_svg__bH",
    x1: 402.449,
    x2: 468.869,
    y1: 276.89,
    y2: 276.89,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1D1D1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1D1D1B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon_404_svg__bI",
    x1: 401.73,
    x2: 465.69,
    y1: 276.93,
    y2: 276.93,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1D1D1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1D1D1B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon_404_svg__bJ",
    x1: 401.012,
    x2: 462.512,
    y1: 276.979,
    y2: 276.979,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1D1D1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1D1D1B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon_404_svg__bK",
    x1: 400.289,
    x2: 459.349,
    y1: 277.021,
    y2: 277.021,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1D1D1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1D1D1B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon_404_svg__bL",
    x1: 399.57,
    x2: 456.19,
    y1: 277.06,
    y2: 277.06,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1D1D1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1D1D1B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon_404_svg__bM",
    x1: 398.852,
    x2: 453.042,
    y1: 277.099,
    y2: 277.099,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1D1D1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1D1D1B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon_404_svg__bN",
    x1: 398.129,
    x2: 449.899,
    y1: 277.14,
    y2: 277.14,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1D1D1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1D1D1B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon_404_svg__bO",
    x1: 397.41,
    x2: 446.77,
    y1: 277.181,
    y2: 277.181,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1D1D1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1D1D1B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon_404_svg__bP",
    x1: 396.691,
    x2: 443.661,
    y1: 277.221,
    y2: 277.221,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1D1D1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1D1D1B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon_404_svg__bQ",
    x1: 395.969,
    x2: 440.569,
    y1: 277.26,
    y2: 277.26,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1D1D1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1D1D1B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon_404_svg__bR",
    x1: 395.25,
    x2: 437.49,
    y1: 277.301,
    y2: 277.301,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1D1D1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1D1D1B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon_404_svg__bS",
    x1: 394.531,
    x2: 434.431,
    y1: 277.34,
    y2: 277.34,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1D1D1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1D1D1B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon_404_svg__bT",
    x1: 393.809,
    x2: 431.389,
    y1: 277.39,
    y2: 277.39,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1D1D1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1D1D1B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon_404_svg__bU",
    x1: 372.21,
    x2: 322.71,
    y1: 24.61,
    y2: 281.11,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DEDEDE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#D7D7D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#C5C5C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#A8A8A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#969696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E2E2E2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon_404_svg__bV",
    x1: 419.78,
    x2: 424.44,
    y1: 30.83,
    y2: 276.17,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#3D3D3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#A9A9A9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#B0B0B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BABABA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon_404_svg__bW",
    x1: 400.99,
    x2: 434.66,
    y1: 157.39,
    y2: 153.06,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon_404_svg__bX",
    x1: 413.62,
    x2: 395.62,
    y1: 13.9,
    y2: 282.9,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D6D6D6"
  })))));
};
export default SvgIcon404;